<template>
  <div class="Highlight-wrapper">
    <TextLabel labelColor="black" :labelText="labelText" />
    <div
      class="h1"
      :class="{
        large: fontSizeProp === 'large',
        small: fontSizeProp === 'small',
      }"
      :style="{
        maxWidth: headingWidthProp ? headingWidthProp + 'px' : '679px',
      }"
    >
      {{ headingText }}
    </div>
    <div
      v-if="textContent"
      class="text"
      :style="{ maxWidth: textMaxWidth ? textMaxWidth + 'px' : '679px' }"
    >
      {{ textContent }}
    </div>
  </div>
</template>

<script>
import TextLabel from "./TextLabel.vue";

export default {
  name: "HighlightSection",
  components: {
    TextLabel,
  },
  props: {
    headingText: {
      type: String,
      required: true,
    },
    textContent: {
      type: String,
      default: "",
    },
    textMaxWidth: {
      type: [Number, String],
      default: 679,
    },
    labelText: {
      type: String,
      default: "Default Label",
    },
    fontSizeProp: {
      type: String,
      default: "large",
      validator(value) {
        return ["large", "small"].includes(value);
      },
    },
    headingWidthProp: {
      type: [Number, String],
      default: 679,
    },
  },
};
</script>

<style scoped>
.Highlight-wrapper {
  width: 100%;
  height: 319px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  text-align: center;
  padding: 70px 0px 60px 0px;
}

.h1 {
  font-weight: 600;
}

.large {
  font-size: 60px;
}

.small {
  font-size: 45px;
}

.text {
  font-size: 16px;
  font-weight: 500;
}

@media (max-width: 1024px) {
  .Highlight-wrapper {
    min-height: 278px;
    height: fit-content;
    padding: 30px 0px 40px 0px;
  }
  .h1 {
    max-width: 340px;
  }

  .large {
    font-size: 30px;
  }

  .small {
    font-size: 30px;
  }

  .text {
    font-size: 14px;
    max-width: 400px;
  }
}

@media (max-width: 744px) {
  .Highlight-wrapper {
    min-height: 178px;
    height: fit-content;
  }
  .h1 {
    max-width: 280px;
  }

  .text {
    font-size: 12px;
  }
}
</style>
